import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import rootReducer from "./reducers/root.reducer";
import { applyMiddleware, createStore } from "redux";
import thunkMiddleware from 'redux-thunk';

const root = ReactDOM.createRoot(document.getElementById('root'));
// const createStoreWithMiddleware = applyMiddleware(ReduxPromise)(createStore);
root.render(
  <Provider store={createStore(rootReducer, applyMiddleware(thunkMiddleware))}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
